function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import InvestmentItemOption from "../../../../components/react-select/InvestmentItemOption";
import InvestmentItemSingleValue from "../../../../components/react-select/InvestmentItemSingleValue";
import SelectField from "../../../../components/redux-form/SelectField";
import { loadInvestmentItemById } from "../../../../actions";
import { operationTypes } from "../../../../constants";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormVariantInvestmentItemStep(props) {
  var type = useSelector(function (state) {
    return selector(state, "type");
  });
  var quote = useSelector(function (state) {
    return selector(state, "quote");
  });
  var investmentItemId = props.investmentItem.id;
  var investmentItemCall = useSelector(function (state) {
    return state.apiCalls.loadInvestmentItemById[investmentItemId] || {};
  });
  var investmentItem = useSelector(function (state) {
    return state.entities.investmentItems.byId[investmentItemId];
  });
  var variantInvestmentItem = useSelector(function (state) {
    return selector(state, "variantInvestmentItem");
  });
  var variantInvestmentItemId = variantInvestmentItem && variantInvestmentItem.id;
  var variantInvestmentItemCall = useSelector(function (state) {
    return state.apiCalls.loadInvestmentItemById[variantInvestmentItemId] || {};
  });
  var variantInvestmentItemOptions = investmentItem && investmentItem.leafs.map(function (leaf) {
    return _objectSpread({
      label: leaf.symbol,
      value: leaf.id
    }, leaf);
  });
  useEffect(function () {
    props.loadInvestmentItemById(investmentItemId);
  }, []);
  useEffect(function () {
    if (variantInvestmentItemId && variantInvestmentItemId !== investmentItemId) props.loadInvestmentItemById(variantInvestmentItemId);
  }, [variantInvestmentItemId]);
  useEffect(function () {
    if (variantInvestmentItemCall && variantInvestmentItemCall.fetchedSuccessfulAtLeastOnce) props.change("variantInvestmentItem", variantInvestmentItem);
  }, [variantInvestmentItemCall]);
  useEffect(function () {
    variantInvestmentItemOptions && variantInvestmentItemOptions.length === 1 && props.change("variantInvestmentItem", variantInvestmentItemOptions[0]);
    variantInvestmentItemOptions && variantInvestmentItemOptions.length > 1 && variantInvestmentItem && props.change("variantInvestmentItem", variantInvestmentItemOptions.find(function (variantOption) {
      return variantOption.id === variantInvestmentItem.id;
    }));
    investmentItem && props.change("variantInvestmentItemRoot", investmentItem);
  }, [investmentItem]);
  return /*#__PURE__*/React.createElement(SelectField, {
    name: "variantInvestmentItem",
    id: "variantInvestmentItem",
    isLoading: investmentItemCall.isFetching,
    options: variantInvestmentItemOptions,
    components: {
      Option: InvestmentItemOption,
      SingleValue: InvestmentItemSingleValue
    },
    isDisabled: type === operationTypes.SELL || quote
  });
}
export default connect(undefined, {
  loadInvestmentItemById: loadInvestmentItemById
})(ExchangeWizardFormVariantInvestmentItemStep);
ExchangeWizardFormVariantInvestmentItemStep.propTypes = {
  loadInvestmentItemById: PropTypes.func
};